import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "addUser",
    serviceName: "unitadmin",
    query: gql`
      mutation addUser(
        $lastname: String
        $firstname: String
        $cellphone: String!
        $birth_date: String
        $national_code: String
        $specialist: String
        $medical_number: String
        $need_activation: Int
        $type_id: String
        $role_id: String
        $gender: Int
      ) {
        addUser(
          lastname: $lastname
          firstname: $firstname
          cellphone: $cellphone
          birth_date: $birth_date
          national_code: $national_code
          specialist: $specialist
          medical_number: $medical_number
          need_activation: $need_activation
          type_id: $type_id
          role_id: $role_id
          gender: $gender
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
